import React from 'react';
import './StoryMediumSkeleton.scss';

const StoryMediumSkeleton: React.FC = () => {
  return (
    <div className="story-medium-skeleton">
      <div className="skeleton skeleton-image"></div>
      <div className="skeleton skeleton-title"></div>
      <div className="skeleton skeleton-description"></div>
      <div className="skeleton skeleton-tags"></div>
    </div>
  );
};

export default StoryMediumSkeleton;